// libs/react-mosaic-component/src/lib/util/assertNever.ts
function assertNever(shouldBeNever) {
  throw new Error("Unhandled case: " + JSON.stringify(shouldBeNever));
}
export {
  assertNever
};
